import Offcanvasnav from "../components/OffCanvas/OffCanvas";
import styled from "styled-components";
import Table from "react-bootstrap/Table";
import { Footer } from "../components/Footer/Footer";
// For test and dev
// import { AppointmentDates } from "../domain/appointments/exampleAppointmentDates";
// For real site
import { AppointmentDates } from "../domain/appointments/AppointmentDates";
import { LimitedAppointments } from "../components/Appointments/Appointments";
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
import SetSeoMeta from "../components/Seo/Seo";

export default function MainPage() {
  return (
    <>
      <SetSeoMeta
        title='1731 - Hauptseite'
        description='Das ist der Eingang zum digitalen Gildehaus - Hier findest du die nächsten Termine und wichtige Bekanntmachungen'
        name='Totengilde Blekendorf von 1731'
        type='article'
      />
      <BackgroundDiv>
        <BackgroundInnerDiv>
          <Offcanvasnav></Offcanvasnav>
          <Headline4>Willkommen bei der</Headline4>
          <h1 style={{ textAlign: "center", color: "#052186" }}>
            Totengilde Blekendorf von 1731
            {/* <img src="images/GildeBlekendorf-von-KO.jpg" alt="Wappen Totengilde Blekendorf von 1731" width="110rem" height="100rem"/> Totengilde Belekendorf von 1731 <img src="images/GildeBlekendorf-von-KO.jpg" alt="Wappen Totengilde Blekendorf von 1731" width="110rem" height="100rem"/> */}
          </h1>
          <AppointmentsDiv>
            <Headline4>Die nächsten Termine</Headline4>
            {/* Details Parken Adr */}
            <Link to="/appointments" style={{ textDecoration: "none" }}>
              <StyledTable striped bordered hover>
                <thead>
                  <tr>
                    <th style={{ backgroundColor: "#ffffff95", fontSize: 23 }}>
                      Datum
                    </th>
                    <th style={{ backgroundColor: "#ffffff95", fontSize: 23 }}>
                      Was
                    </th>
                    <th style={{ backgroundColor: "#ffffff95", fontSize: 23 }}>
                      Wer
                    </th>
                    <th style={{ backgroundColor: "#ffffff95", fontSize: 23 }}>
                      Wo
                    </th>
                    <th style={{ backgroundColor: "#ffffff95", fontSize: 23 }}>
                      Kontakt
                    </th>
                  </tr>
                </thead>
                <LimitedAppointments appointments={AppointmentDates} />
              </StyledTable>
            </Link>
          </AppointmentsDiv>
          <NewsDiv>
            <Headline4>Bekanntmachungen</Headline4>
            <p>
              <span>
                Jeden 1. Donnerstag im Monat 19:00-21:00 Uhr Übungsschießen für
                jeden (1,00€/Scheibe)
              </span>
            </p>
          </NewsDiv>
          <Banner>
            <a
              href="http://www.pokaldiscounter.de/"
              title="Pokale Medaillen Trophäen"
            >
              <BannerImage
                src="http://www.pokaldiscounter.de/bilder/banner/pokaldiscounter-234x60.png"
                alt="Pokale Medaillen Trophäen | pokaldiscounter.de"
              />
              Medaillen und Pokale kaufen
            </a>
          </Banner>
        </BackgroundInnerDiv>
      </BackgroundDiv>
      <Footer />
    </>
  );
}

const BackgroundDiv = styled.div`
  /* background-image: url("images/GildeBlekendorf-von-KO.jpg") !important; */
  background-image: url("images/Gildehaus_DSC04187_10.jpg") !important;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 70%;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  position: relative;
  // background-position-x: center;
  min-height: 100vh;
  max-height: 100%;
  /* overflow: scroll; */
  // width: 100%;
  // margin: 0;
  // @media (min-width: 1250px) {
  //   background-size: 100%;
  // }
  /* border: 2px red solid; */
`;

const BackgroundInnerDiv = styled.div`
  background: linear-gradient(
    /* #ffffff10 0%,
    white 100% */ 0.25deg,
    #fffffffa,
    #ebf8e185,
    #fffffffa
  );
  min-height: 100vh;
  /* border: 2px solid blue; */
`;

const AppointmentsDiv = styled.div`
  min-width: 50%;
  margin: auto;
  padding: 0.5rem 4rem;
  align-self: right;
  text-align: center;
  // border: 2px orange solid;
`;

const NewsDiv = styled.div`
  min-width: 50%;
  margin: auto;
  padding: 0.5rem 4rem;
  align-self: right;
  text-align: center;
  font-size: 1.2rem;
  // border: 2px red solid;
`;

const Headline4 = styled.h4`
  text-align: center;
  color: #052186;
  padding-top: 1rem;
  /* font-size: 33px; */
`;

// No More Tables
const StyledTable = styled(Table)`
  @media only screen and (max-width: 800px) {
    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border: 1px solid #66c4fa7a;
    }

    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #dadada;
      position: relative;
      padding-left: 6.5rem;
      white-space: normal;
      text-align: left;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 6px;
      left: 6px;
      max-width: 45%;
      padding-right: 10px;
      white-space: nowrap;
      text-align: left;
      font-weight: bold;
    }

    td {
      border: none !important;
    }

    /*
	Label the data
	*/
    td:before {
      content: attr(data-title);
    }
  }
`;

const Banner = styled.div`
  width: 234px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
  font-size: 10px;
`;

const BannerImage = styled.img`
  display: block;
  width: 234px;
  height: 60px;
  border: 0;
`;
